module.exports = __webpack_public_path__ + "img/shoplogo.509a38bb.svg";